import { FC } from 'react';
import classNames from 'classnames';

import type { MeetChatMessage } from '../../../features/meet/chat/types';
import { CloseCrossBtn } from '../../icons/close-cross-btn';

import { MeetChatComposer } from './meet-chat-composer';
import { MeetChatMessageList } from './meet-chat-message-list';

interface MeetChatPanelProps {
  isOpen: boolean;
  messages: MeetChatMessage[];
  draft: string;
  isSendingImage?: boolean;
  disabled?: boolean;
  onDraftChange: (value: string) => void;
  onSend: () => void | Promise<boolean>;
  onImageSelect: (file: File) => void | Promise<boolean>;
  onClose: () => void;
}

export const MeetChatPanel: FC<MeetChatPanelProps> = ({
  isOpen,
  messages,
  draft,
  isSendingImage = false,
  disabled = false,
  onDraftChange,
  onSend,
  onImageSelect,
  onClose,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className={classNames(
        'fixed z-[70] flex flex-col overflow-hidden bg-white shadow-[0_12px_32px_rgba(0,0,0,0.18)]',
        'inset-x-0 bottom-[60px] top-0 w-full max-w-none rounded-none border-0',
        'pt-[env(safe-area-inset-top,0px)]',
        'sm:inset-x-auto sm:left-3 sm:right-auto sm:top-3 sm:bottom-[65px] sm:w-[min(100%,400px)] sm:max-w-[calc(100vw-24px)] sm:rounded-[16px] sm:border sm:border-[#D9D9D9]',
        'md:w-[440px] md:max-w-[calc(100vw-32px)] md:rounded-[20px]',
        'lg:w-[560px]',
      )}
      role="dialog"
      aria-label="Чат встречи"
    >
      <div className="flex shrink-0 items-center justify-between border-b border-[#E5E5E5] px-3 py-2.5 sm:px-4 sm:py-3">
        <p className="truncate pr-2 text-sm font-semibold text-[#111026] sm:text-base">Чат встречи</p>
        <button
          type="button"
          onClick={onClose}
          className="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-full hover:bg-[#F3F3F3]"
          aria-label="Закрыть чат"
        >
          <CloseCrossBtn width={16} height={16} />
        </button>
      </div>

      <MeetChatMessageList messages={messages} />
      <MeetChatComposer
        draft={draft}
        isSendingImage={isSendingImage}
        disabled={disabled}
        onDraftChange={onDraftChange}
        onSend={onSend}
        onImageSelect={onImageSelect}
      />
    </div>
  );
};
